function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 84.5,
  cy: 84.5,
  r: 83.5,
  fill: "#F4F4F4",
  stroke: "#002F42",
  strokeWidth: 2
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M114.167 80.834H55.8333C51.231 80.834 47.5 84.5649 47.5 89.1673V118.334C47.5 122.936 51.231 126.667 55.8333 126.667H114.167C118.769 126.667 122.5 122.936 122.5 118.334V89.1673C122.5 84.5649 118.769 80.834 114.167 80.834Z",
  stroke: "#002F42",
  strokeWidth: 5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M64.1667 80.834V64.1673C64.1667 58.642 66.3617 53.3429 70.2687 49.4359C74.1757 45.5289 79.4747 43.334 85.0001 43.334C90.5254 43.334 95.8245 45.5289 99.7315 49.4359C103.638 53.3429 105.833 58.642 105.833 64.1673V80.834",
  stroke: "#002F42",
  strokeWidth: 5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 169,
    height: 169,
    viewBox: "0 0 169 169",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/Lock.10aa3a9e52b4443a6a6c31d07d68a1d6.svg";
export { ForwardRef as ReactComponent };